import { post } from './commonFetch';
import { TravelerLoginInfo, TravelerForgotPasswordInfo } from '../types/travelerLogin';
import { AuthResponse } from '../types/auth';
import { TravelerProfileLogin, TravelerForgotLogin } from '../../js/appRoutes';

export const travelerLogin = (
  travelerLoginInfo: TravelerLoginInfo,
): Promise<AuthResponse> => {
  return post(TravelerProfileLogin, travelerLoginInfo);
};

export const travelerForgotPassword = (
  travelerForgotPasswordInfo: TravelerForgotPasswordInfo,
): Promise<AuthResponse> => {
  return post(TravelerForgotLogin, travelerForgotPasswordInfo);
};